import {
  LOADING_NOTIFICATIONS,
  LIST_NOTIFICATIONS,
  TOGGLE_NOTIFICATIONS_PANEL,
} from "../../constants/types";
import { INotification } from "../../types/notification/inotification.interface";

export interface INotificationsState {
  notifications: NotificationsState;
}

export interface NotificationsState {
  loading: boolean;
  count: number;
  next: number | null;
  previous: number | null;
  notifications: INotification[];
  isPanelOpen: boolean;
  totalUnread: number;
}
const initialState: NotificationsState = {
  loading: false,
  count: 0,
  next: null,
  previous: null,
  notifications: [],
  isPanelOpen: false,
  totalUnread: 0,
};

const notificationsReducer = (state = initialState, action: any) => {
  const { notifications } = action.payload || {};
  switch (action.type) {
    case LOADING_NOTIFICATIONS:
      return {
        ...state,
        loading: true,
      };
    case LIST_NOTIFICATIONS:
      return {
        ...state,
        loading: false,
        notifications,
        totalUnread: notifications ? notifications.filter((n: any) => n.unread === true).length : 0,
      };
    case TOGGLE_NOTIFICATIONS_PANEL:
      return {
        ...state,
        loading: false,
        isPanelOpen: !state.isPanelOpen,
      };

    default:
      return state;
  }
};

export default notificationsReducer;
